import { styled, Box, Grid, AutocompleteV2 } from '@ltvco/refresh-lib/theme';

import { OptionType } from './utils';

export const StatesSelect = styled(
  AutocompleteV2<OptionType, true, true, false>
)(({ theme }) => ({
  height: '100%',
  minWidth: '320px',
  paddingLeft: '0',

  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    '& fieldset': {
      border: 'none',
    },
  },

  '.MuiAutocomplete-input': {
    padding: '0px !important',
  },

  '& .MuiAutocomplete-popupIndicator': {
    color: theme.palette.primary.main,
  },

  '.MuiAutocomplete-endAdornment': {
    height: 'auto',
    backgroundColor: 'transparent',
  },

  '.MuiAutocomplete-tag': {
    backgroundColor: 'transparent',
    height: '27px',
  },

  '.MuiChip-root': {
    margin: '0px',
  },

  '.MuiChip-label': {
    paddingLeft: '0px',
  },

  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    padding: theme.spacing(0.5),
    paddingLeft: '12px',
    paddingRight: '0px',
  },
}));

export const UnclaimedMoneySearchContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: '32px',
  padding: theme.spacing(0.375, 1),
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(4, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },
}));

export const UnclaimedMoneySearchDivider = styled(Box)(({ theme }) => ({
  height: '50px',
  width: '1px',
  backgroundColor: theme.palette.divider,
  margin: theme.spacing(0, 1),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const UnclaimedMoneyFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
